"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crossCheckConfig = crossCheckConfig;
const config_issue_js_1 = require("./config-issue.js");
const measures_js_1 = require("./measures.js");
const organization_js_1 = require("./organization.js");
const synthetic_cross_check_js_1 = require("./synthetic-cross-check.js");
const organizationIssue = (path, message) => ({
    document: "organization",
    path: (0, config_issue_js_1.formatIssuePath)(path),
    message,
});
function checkGroupsAgainstMeasures(organization, year, doc) {
    const pathways = new Set(doc.pathways.map((pathway) => pathway.code));
    const measures = new Set(doc.measures.map(measures_js_1.measureIdentity));
    const issues = [];
    // J-268: both shapes, each issue at the group's own path.
    for (const group of (0, organization_js_1.organizationGroups)(organization)) {
        const at = group.path;
        if (!pathways.has(group.pathway)) {
            const message = `pathway ${group.pathway} is not in measures/${year}`;
            issues.push(organizationIssue([...at, "pathway"], message));
        }
        group.measures.forEach((measure, m) => {
            const identity = (0, measures_js_1.measureIdentity)(measure);
            if (measures.has(identity))
                return;
            const message = `measure ${identity} is not in measures/${year}`;
            issues.push(organizationIssue([...at, "measures", m, "number"], message));
        });
    }
    return issues;
}
function checkBenchmarkSources(documents) {
    return Object.entries(documents.measures).flatMap(([year, doc]) => {
        const source = doc.scoring_parameters.benchmark_source;
        if (source === measures_js_1.BENCHMARK_SOURCE_CMS_FILE || source in documents.benchmarks)
            return [];
        return [
            {
                document: `measures/${year}`,
                path: "scoring_parameters.benchmark_source",
                message: `benchmark_source ${source} is neither ${measures_js_1.BENCHMARK_SOURCE_CMS_FILE} nor a benchmark set name`,
            },
        ];
    });
}
/** Every broken link between the organization, the measures, the benchmark sets and synthetic data. */
function crossCheckConfig(documents) {
    const year = String(documents.organization.performance_year);
    const measures = documents.measures[year];
    const groupIssues = measures === undefined
        ? [
            organizationIssue(["performance_year"], `no measures document for performance year ${year} (expected measures/${year})`),
        ]
        : checkGroupsAgainstMeasures(documents.organization, year, measures);
    return [
        ...groupIssues,
        ...checkBenchmarkSources(documents),
        ...(0, synthetic_cross_check_js_1.crossCheckSynthetic)(documents.organization, documents.synthetic),
    ];
}
//# sourceMappingURL=cross-check.js.map